import React, { Component } from 'react';
import './Map.scss';

import mapjson from './MapStyle.json'
import { GoogleMap, LoadScript, MarkerClusterer, Marker } from '@react-google-maps/api';
import dirt_icon from '../../Assets/dirt-icon.svg'
import wtl_icon from '../../Assets/wtl-icon.svg'

const mapContainerStyle = {
  height: '100%',
  width: '100%',
}

const center = { lat: 53.059796, lng: -111.042691 }

const options = {  
  imagePath:
    '', // so you must have m1.png, m2.png, m3.png, m4.png, m5.png and m6.png in that folder
}

const mapOptions = {
	panControl: false,
	mapTypeControl: false,
	scrollwheel: true,
	styles: mapjson
}

class Map extends Component {

	constructor(props){
		super(props)
		this.state = {currentLocation: 1};
		this.markerClickHandler = this.markerClickHandler.bind(this);
		
	}
	componentWillReceiveProps = (nextProps) => {
		if (nextProps.position !== this.props.position) {
		  this.moveMap(nextProps.position)
		}
		this.filteredLocations = nextProps.locations.filter(location => {
			if(location.date_obj > nextProps.activeDate.start && location.date_obj < nextProps.activeDate.end){
				if(nextProps.activeFilters.locate_requested === true){
					if(nextProps.activeFilters[location.type] && (location.locate_requested === "true" || location.locate_requested === "TRUE")){
						return true;
					}else{
						return false;
					}
				}else{
					if(nextProps.activeFilters[location.type]){
						return true;
					}else{
						return false;
					}
				}
			}else{
				return false;
			}
		});
	}	
	markerClickHandler(location){
		console.log(location);
		this.setState({currentLocation:location});
		this.props.setCurrentLocation(location);
	}
	render() {
		return (
			<div className='Map' >
			<LoadScript googleMapsApiKey='AIzaSyB0bD4eeXK7ACx8tMQ6JbwxR3DgC1WdS6U'>
			<GoogleMap id='marker-example' mapContainerStyle={mapContainerStyle} zoom={6} center={center} options={mapOptions}>
				<MarkerClusterer options={options}>
				{(clusterer) =>
					this.filteredLocations ? this.filteredLocations.map((location, i) => {
						let noClustererRedraw = (i === (this.filteredLocations.length - 1)) ? false : true;
						return(							
							<Marker noClustererRedraw={noClustererRedraw} onClick={() => this.markerClickHandler(location)} key={i} position={location} clusterer={clusterer} icon={location.type === 'underground' ? dirt_icon: wtl_icon}/>							
						)					
					}) : <></>
				}				
				</MarkerClusterer>
			</GoogleMap>
			</LoadScript>
			</div>
		)
	}
}
  export default Map;